export default __webpack_public_path__ + "static/0111-d1bfc4486d1d8a1f89f9dcc15b681214.png";